import { module as BaseModule } from "modujs";

const SELECTOR = "[data-phone-format]";
const FREEFORM_RENDER_SUCCESS_EVENT = "freeform-render-success";
const FREEFORM_RENDER_ERROR_EVENT = "freeform-render-form-errors";
const FREEFORM_AJAX_SUCCESS_EVENT = "freeform-ajax-success";

export default class PhoneFormatter extends BaseModule {
  init() {
    this.inputs = [];

    this.handleInput = this.handleInput.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleRebind = this.handleRebind.bind(this);

    this.attachEventListeners();
    this.rebindInputs();
  }

  attachEventListeners() {
    document.addEventListener(FREEFORM_RENDER_SUCCESS_EVENT, this.handleRebind);
    document.addEventListener(FREEFORM_RENDER_ERROR_EVENT, this.handleRebind);
    document.addEventListener(FREEFORM_AJAX_SUCCESS_EVENT, this.handleRebind);
  }

  detachEventListeners() {
    document.removeEventListener(
      FREEFORM_RENDER_SUCCESS_EVENT,
      this.handleRebind
    );
    document.removeEventListener(
      FREEFORM_RENDER_ERROR_EVENT,
      this.handleRebind
    );
    document.removeEventListener(
      FREEFORM_AJAX_SUCCESS_EVENT,
      this.handleRebind
    );
  }

  destroy() {
    this.detachInputs();
    this.detachEventListeners();
  }

  handleRebind() {
    this.rebindInputs();
  }

  detachInputs() {
    this.inputs.forEach((input) => {
      input.removeEventListener("input", this.handleInput);
      input.removeEventListener("blur", this.handleBlur);
    });

    this.inputs = [];
  }

  rebindInputs() {
    this.detachInputs();
    this.inputs = Array.from(this.el.querySelectorAll(SELECTOR));

    if (!this.inputs.length) {
      return;
    }

    this.inputs.forEach((input) => {
      input.addEventListener("input", this.handleInput);
      input.addEventListener("blur", this.handleBlur);
      // format any prefilled value
      this.applyFormat(input, { trim: true, close: true });
    });
  }

  handleInput(event) {
    const input = event.target;
    this.applyFormat(input, { trim: false, close: false });
  }

  handleBlur(event) {
    const input = event.target;
    this.applyFormat(input, { trim: true, close: true });
  }

  applyFormat(input, { trim = false, close = true } = {}) {
    const raw = input.value || "";
    const digits = raw.replace(/\D+/g, "");

    const normalized = digits.startsWith("1") ? digits.slice(1) : digits;
    const maxLength = 10;
    const limitedDigits = trim ? normalized.slice(0, maxLength) : normalized;

    const formatted = this.formatDigits(limitedDigits, { closeParenthesis: close });

    if (formatted !== undefined) {
      input.value = formatted;
    }
  }

  formatDigits(digits, { closeParenthesis = true } = {}) {
    if (!digits) return "";

    const part1 = digits.slice(0, 3);
    const part2 = digits.slice(3, 6);
    const part3 = digits.slice(6, 10);

    let formatted = "";
    if (part1) {
      formatted += `(${part1}`;
      if (part1.length === 3 && (closeParenthesis || part2 || part3)) {
        formatted += ")";
      }
    }

    if (part2) {
      formatted += part1.length === 3 ? ` ${part2}` : part2;
    }

    if (part3) {
      formatted += part2.length ? `-${part3}` : part3;
    }

    return formatted;
  }
}
